export const sortBy = (key: string) => (a: any, b: any) =>
  // eslint-disable-next-line no-nested-ternary
  a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
